import { useTranslations } from "use-intl";
import { Button } from "@mui/material";
import { Image } from "@/app/ui/Image";
import { SwipeableDrawer } from "./SwipeableDrawer";
import { useState } from "react";

type CheckoutDrawerProps = {
  open: boolean;
  onClose: () => void;
};

export function CheckoutDrawer({ open, onClose }: CheckoutDrawerProps) {
  const t = useTranslations();

  return (
    <SwipeableDrawer open={open} onClose={onClose}>
      <div className="mt-2 mb-6 flex flex-col gap-1">
        <div className="font-medium text-text-title">
          {t("checkoutBanner.drawer.title")}
        </div>

        <ul className="mt-3 list-disc ps-5 text-sm text-text-primary marker:text-xs">
          <li>{t("checkoutBanner.drawer.point1")}</li>
          <li>{t("checkoutBanner.drawer.point2")}</li>
          <li>{t("checkoutBanner.drawer.point3")}</li>
          <li>{t("checkoutBanner.drawer.point4")}</li>
          <li>{t("checkoutBanner.drawer.point5")}</li>
        </ul>
      </div>

      <Button variant="contained" size="large" onClick={onClose}>
        {t("common.close")}
      </Button>
    </SwipeableDrawer>
  );
}

export function CheckoutBanner() {
  const t = useTranslations();
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <>
      <div className="rounded-4xl bg-white p-1">
        <Image
          src="/banners/checkout.jpg"
          className="rounded-t-3xl"
          onClick={() => setDrawerOpen(true)}
        />
        <div className="p-3">
          <div className="mb-3 font-medium text-text-primary">
            {t("checkoutBanner.title")}
          </div>
          <Button variant="outlined" onClick={() => setDrawerOpen(true)}>
            {t("checkoutBanner.buttonLabel")}
          </Button>
        </div>
      </div>

      <CheckoutDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
    </>
  );
}
